export const TRANSLATION_BASE = "calculators.spousalMaintenance";
